module.exports = __webpack_public_path__ + "img/Projecttop.2c91daa6.jpg";